// The supplied outline follows source-image pixels. Smooth those tiny steps in
// source-pixel space, then let the browser rasterize the curve at its display
// size. The photograph and the positions of art layers stay unchanged.
const cache=new Map();
const distance=(a,b)=>Math.hypot(a[0]-b[0],a[1]-b[1]);
export function smoothNailContour(path,width,height) {
 if(typeof path!=='string'||!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0||/[^MLZ0-9.,\s-]/.test(path))return path;
 const key=`${width}:${height}:${path}`;if(cache.has(key))return cache.get(key);
 const coordinates=path.match(/-?\d+(?:\.\d+)?/g)?.map(Number)||[];
 if(coordinates.length<8||coordinates.length%2)return path;
 const points=[];for(let i=0;i<coordinates.length;i+=2)points.push([coordinates[i]*width/100,coordinates[i+1]*height/150]);
 if(distance(points[0],points.at(-1))<.001)points.pop();
 const sampled=[];
 let residual=0;
 for(let index=0;index<points.length;index++){
  const point=points[index],end=points[(index+1)%points.length],length=distance(point,end);
  for(;residual<length;residual+=1.8)sampled.push(point.map((value,axis)=>value+(end[axis]-value)*residual/length));
  residual-=length;
 }
 if(sampled.length<4)return path;
 const weights=[1,4,6,4,1],outline=sampled.map((point,index)=>point.map((_,axis)=>weights.reduce((sum,weight,offset)=>sum+weight*sampled[(index+offset-2+sampled.length)%sampled.length][axis],0)/16));
 const midpoint=(a,b)=>a.map((value,index)=>(value+b[index])/2);
 const format=point=>`${+(point[0]*100/width).toFixed(4)} ${+(point[1]*150/height).toFixed(4)}`;
 const result=`M${format(midpoint(outline.at(-1),outline[0]))}`+outline.map((point,index)=>`Q${format(point)} ${format(midpoint(point,outline[(index+1)%outline.length]))}`).join('')+'Z';
 cache.set(key,result);return result;
}
